import React, { useRef, useEffect } from "react";
import "./AccountDropdown.scss";
import { useDispatch } from "react-redux";
import { removeUser } from "../../../../../redux/user/user.action";
import { resetCartItem } from "../../../../../redux/shopping-cart/shopping-cart.action";
import PrimaryCustomButton from "../../../../commons/primary-custom-button/primary-custom-button.component";
import { useHistory } from 'react-router-dom';

function AccountDropdown({ showSignInMenu, setShowSignInMenu, user, isAdminUser }) {
  const dropdownRef = useRef(null);
  const dispatch = useDispatch();
  const history = useHistory();

  const logOutClick = () => {
    dispatch(removeUser(null));
    dispatch(resetCartItem(null));
    setTimeout(() => {
      history.push("/login");
    }, 1000);
    setShowSignInMenu(false);
  };

  // Close when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target)
      ) {
        setShowSignInMenu(false);
      }
    };

    if (showSignInMenu) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    // Cleanup
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showSignInMenu, setShowSignInMenu]);

  return (
    <div
      ref={dropdownRef}
      className={`account-dropdown ${
        showSignInMenu ? "dropdown-open" : "dropdown-closed"
      }`}
    >
      {!user ? (
        <div className="dropdown-content">
          <a href="/login">
            <button className="dropdown-btn">Sign In</button>
          </a>
          <a href="/create-account">
            <button className="dropdown-btn">Create New Account</button>
          </a>
        </div>
      ) : (
        <div className="dropdown-content">
          <a href="/my-account">
            <PrimaryCustomButton
              customClass="w-100"
              label="My Account"
              onClick={() => {}}
            />
          </a>
          {isAdminUser && (
            <a href="/admin/landingPage">
              <PrimaryCustomButton
                customClass="w-100"
                label="Admin Home"
                onClick={() => {}}
              />
            </a>
          )}
          <a href="#">
            <PrimaryCustomButton
              customClass="w-100"
              label="Logout"
              onClick={logOutClick}
            />
          </a>
        </div>
      )}
    </div>
  );
}

export default AccountDropdown;
